import React from 'react';

import { AllFilters as AllFiltersProvider } from 'components/Filters';

import { Grid } from '@gogame/components';
import { useScreenDispatch } from '@gogame/screens';

import ApplyFiltersButton from 'scenes/Trackers/HourlyTracker/components/Filters/ApplyFiltersButton';
import { APPLY } from 'scenes/Trackers/HourlyTracker/reducers';

import HourlyTrackerFilters from './filters';

const AllFilters = ({ open, onClose, onExited }) => {
  const dispatch = useScreenDispatch();

  const handleApply = () => {
    dispatch({
      type: APPLY,
    });

    onClose();
  };

  return (
    <AllFiltersProvider
      open={open}
      onClose={onClose}
      onExited={onExited}
      applyButton={<ApplyFiltersButton onClick={handleApply} />}
    >
      <Grid container={true} spacing={2}>
        <Grid item xs>
          <HourlyTrackerFilters.Date componentWidth={268} />
        </Grid>
        <Grid item xs={4}>
          <HourlyTrackerFilters.TimeZone />
        </Grid>
        <Grid item xs={4}>
          <HourlyTrackerFilters.Applications />
        </Grid>

        <Grid item xs={4}>
          <HourlyTrackerFilters.Networks withFavoriteActions={true} />
        </Grid>

        <Grid item xs={4}>
          <HourlyTrackerFilters.Platforms withFavoriteActions={true} />
        </Grid>
        <Grid item xs={4}>
          <HourlyTrackerFilters.TrafficType withFavoriteActions={true} />
        </Grid>
        <Grid item xs={4}>
          <HourlyTrackerFilters.Countries withFavoriteActions={true} />
        </Grid>
        <Grid item xs={4}>
          <HourlyTrackerFilters.Affiliates
            dropdownWidth={'440px'}
            withFavoriteActions={true}
          />
        </Grid>
        <Grid item xs={4}>
          <HourlyTrackerFilters.Managers withFavoriteActions={true} />
        </Grid>
        <Grid item xs={4}>
          <HourlyTrackerFilters.Owners withFavoriteActions={true} />
        </Grid>
      </Grid>
    </AllFiltersProvider>
  );
};

export default AllFilters;
